import React from 'react';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import OptionsCommon from 'components/show_drawing/redraw_form/options/OptionsCommon.jsx';
import ShowHideChildOptions from 'components/show_drawing/redraw_form/options/ShowHideChildOptions.jsx';

const FLUTE_DIRECTION_VERTICAL = 1;
const FLUTE_DIRECTION_HORIZONTAL = 0;
const FLUTE_DIRECTION_NOT_INCLUDED = 2;

const OptionFluteDirection = ({ id, drawing, option, unit, setRedrawRequested, optionsUserChanged, addToOptionsUserChanged, labelGroup = 'dimensions', inputName }) => {
  const submitName = inputName ?? option.name;
  const formattedValue = (value) => { return parseFloat(value) }
  const redrawOnChange = true;
  const [isVisible, value, valueAutoCalculated, recommendedValue, onChange, showAbcHelperLine, changed, highlighted, d_input_add_on_ref] = OptionsCommon( { formattedValue, id, drawing, option, unit, optionsUserChanged, addToOptionsUserChanged, setRedrawRequested, redrawOnChange, labelGroup } )

  const onSelectChange = (e) => {
    onChange({ target: { value: parseFloat(e.target.value) } })
  }

  const getShowHideChildOptions = () => {
    if (option.children.length == 0) { return }
    return <ShowHideChildOptions id={id} option={option} />
  }

  if (!isVisible) { return <input type="hidden" name={submitName} value={value} /> }

  return (
    <div className={`${styles.row} ${styles.booleanGridItemWide}`}>
      <div className={`input-group ${highlighted ? styles.highlighted : ''}`} style={{ width: '100%' }}>
        <span className={`d_input_add_on input-group-addon input-group-addon-${window.locale} ${styles.input_add_on}`} ref={d_input_add_on_ref}>
          {option.description_en}
        </span>

        <select
          name={submitName}
          value={value}
          onChange={onSelectChange}
          className="drawing-option-input autoredrawonchange form-control"
          disabled={option.readonly_option}
        >
          <option value={FLUTE_DIRECTION_VERTICAL}>{t('drawing.flute_direction_vertical')}</option>
          <option value={FLUTE_DIRECTION_HORIZONTAL}>{t('drawing.flute_direction_horizontal')}</option>
          <option value={FLUTE_DIRECTION_NOT_INCLUDED}>{t('drawing.flute_direction_not_included')}</option>
        </select>
      </div>

      {valueAutoCalculated && <> <small> { t('drawing.this_has_been_automaticly_calculated') } </small> { getShowHideChildOptions()} {option.children.length == 0 && <br /> } </> }
      {!valueAutoCalculated && option.value_formula && recommendedValue !== undefined &&  <> <small> {t('drawing.choose_option_recommmended')}: {recommendedValue == FLUTE_DIRECTION_VERTICAL ? t('drawing.flute_direction_vertical') : recommendedValue == FLUTE_DIRECTION_NOT_INCLUDED ? t('drawing.flute_direction_not_included') : t('drawing.flute_direction_horizontal')} </small> { getShowHideChildOptions() } </>}
      {!valueAutoCalculated && !(option.value_formula && recommendedValue !== undefined) &&  <> { getShowHideChildOptions() } </>}
    </div>
  )
}

export default OptionFluteDirection;
